module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-auspost.json
// module id = 360
// module chunks = 107279995824068